export default __webpack_public_path__ + "static/media/work.b21bb84c.png";